import { useEffect, useState } from "react";
import { AmazonLoginButton } from "react-social-login-buttons";
import { useFormContext } from "react-hook-form";

/* global amazon */ //

function Amazon() {
    const [profile, setProfile] = useState(null);
    const { setValue } = useFormContext();
    const [sdkReady, setSdkReady] = useState(false);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://assets.loginwithamazon.com/sdk/na/login1.js";
        script.async = true;
        script.onload = () => {
            if (window.amazon) {
                amazon.Login.setClientId("amzn1.application-oa2-client.c09926723ca7444c82b8fa1a1ebe1ccb");
                setSdkReady(true);
            }
        };
        document.body.appendChild(script);
    }, []);

    const handleAmazonLogin = () => {
        if (!sdkReady) {
            console.error("Amazon SDK not loaded yet");
            return;
        }

        amazon.Login.authorize(
            {
                scope: "advertising::campaign_management advertising::audiences profile",
                response_type: "code",
                redirect_uri: "http://localhost:3000",
            },
            (response) => {
                if (response.error) {
                    console.error("Amazon login error:", response.error);
                    return;
                }
                setValue("token", response.code);
                setProfile({ name: "Authorized" });
            }
        );
    };

    return (
        <div>
            {!profile ? (
                <div>
                    <div className="create-destination__platform-header">
                        Authorize your Amazon connection:
                    </div>
                    <AmazonLoginButton onClick={handleAmazonLogin} />
                </div>
            ) : (
                <div>
                    <div className="create-destination__platform-header">
                        Your Amazon authorization code has been obtained
                    </div>
                </div>
            )}
        </div>
    );
}

export default Amazon;